import React from 'react';
import cn from 'classnames';
import {withStyles} from '@material-ui/core';
import BaseComponent from '../BaseComponent';
import styles from './styles';

const CreditCardItem = ({classes, className, ...rest}) => (
    <BaseComponent className={cn(classes.cardItem, className, 'creditCardItem')} {...rest}/>);

export const CardDigits = ({digits, className, ...rest}) => (
    <BaseComponent className={cn('digits', className)} {...rest}>●●●● ●●●● ●●●● {digits}</BaseComponent>
);

export const CardBrand = ({className, ...rest}) => (
    <BaseComponent className={cn('brand', className)} {...rest}/>
);

export const CardIcon = ({className, ...rest}) => (
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 24 24"
         className={cn('cardIcon', className)}
         {...rest}>
        <g>
            <path id="path1"
                  transform="rotate(0,12,12) translate(0,3.75) scale(0.75,0.75)  "
                  fill="#000000"
                  d="M18,16L25,16C25.552999,16 26,16.448 26,17 26,17.552 25.552999,18 25,18L18,18C17.447001,18 17,17.552 17,17 17,16.448 17.447001,16 18,16z M2,11L2,20 30.000977,20 30.000488,11z M2,7L2,9 30.00038,9 30.000271,7z M2,2L2,5 30.000162,5 30,2z M2,0L30,0C31.103027,0,32,0.89700317,32,2L32,20C32,21.102997,31.103027,22,30,22L2,22C0.89697266,22,0,21.102997,0,20L0,2C0,0.89700317,0.89697266,0,2,0z"/>
        </g>
    </svg>);

CardIcon.defaultProps = {
    width: "24",
    height: "24",
};

export default withStyles(styles)(CreditCardItem);
